<script>
    // Import general mixin for shared functionality.
    import mixin from './../mixin';
    import constants from './../../constants.js';

    import SourceSet from './SourceSet.vue';

    export default {
        components: { SourceSet },
        mixins: [mixin],
        props: {
            item: {
                type: Object,
                required: true
            },
        },
        data() {
            return {
                constants: constants,
            };
        },
        computed: {
            type() {
                return this.item?.type?.[0]?.name ?? null;
            },
            region() {
                return this.item?.regio?.[0]?.name ?? null;
            },
        }
    }
</script>

<template>
    <div class="column is-one-third-desktop">
        <a :href="item.detailUrl"
           class="card card--normal is-block is-clipped has-border">
            <div v-if="item.image && item.image.length"
                 class="card-image is-clipped">
                <source-set :image-sets="item.image" />
            </div>
            <div class="card-content has-background-transparent is-flex is-flex-direction-column is-justify-content-flex-end">
                <h3 v-if="item.title"
                    class="title is-5 mb-4">
                    {{ item.title }}
                </h3>
                <div v-if="region || type"
                     class="card-content__metadata">
                    <span v-if="region"
                          class="is-nowrap">
                        <span class="icon mr-1"><i class="fa-solid fa-location-dot"></i></span>
                        <span>{{ region }}</span>
                    </span>
                    <span v-if="region && type">|</span>
                    <span v-if="type">{{ type }}</span>
                </div>
            </div>
        </a>
    </div>
</template>
